import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSession } from '../../state/session.tsx';
import { companyHasPlanFeature } from '../../components/plan-gate.tsx';
import { DemoLimitedSection } from '../../components/demo-limit-note.tsx';
import IntegrationsSection from '../../components/integrations-section.tsx';
import { AccountSettingsFrame } from './account.tsx';

/**
 * /settings/integrations: whose mailbox and calendar the app may act through.
 * A connect round trip returns here (with `#integrations`, the fragment the
 * OAuth legs have always appended), and the section reads its outcome from
 * the query string. The public demo still shows the limited note instead.
 *
 * Not the company calendar links (Settings → Calendar links): those publish
 * the schedule as subscribe feeds, and are the company's rather than this
 * person's. The footer points there, for whoever came looking for them.
 */
export default function IntegrationsPage() {
  const { t } = useTranslation();
  const { company, can, publicDemo } = useSession();
  const showFeeds = can('schedule:read') && companyHasPlanFeature(company, 'scheduling');
  return (
    <AccountSettingsFrame current="integrations" anchorId="integrations">
      {publicDemo ? (
        <DemoLimitedSection heading={t('publicDemo.integrationsHeading')} note={t('publicDemo.integrationsNote')} />
      ) : (
        <IntegrationsSection returnTo="/settings/integrations" />
      )}
      {showFeeds ? (
        <p className="text-sm text-[color:var(--color-muted)]">
          {t('settings.accountHub.feedsHint')}{' '}
          <Link
            className="font-semibold text-[color:var(--color-brand)] hover:underline"
            to="/settings#settings-calendar"
          >
            {t('settings.accountHub.feedsLink')}
          </Link>
        </p>
      ) : null}
    </AccountSettingsFrame>
  );
}
